<template>
  <div>
    <Head v-if="route.params?.team && team?.slug">
      <Title>{{ team?.name }} - Fans48</Title>
      <Meta name="description" :content="team?.fullName" />
    </Head>
    <div class="mx-auto max-w-xl px-2">
      <div v-if="route.params?.team && team?.slug">
        <TeamDetails />
        <div class="space-y-3 my-2 lg:mt-6" v-auto-animate>
          <TeamFeaturedGame v-if="route.name === 'team'" />
          <TeamBreadcrumbs v-if="route.name !== 'team'" />
          <TeamHeading v-if="route.name !== 'team' && route.name !== 'team-game'" />
          <TeamNav v-if="route.name !== 'team-game'" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const team = useTeamStore()

// Validate team slug to throw error
const validateTeamSlug = () => {
  if (!team.slug) {
    throw createError({
      statusCode: 404,
      message: 'not found',
      fatal: true
    })
  }
}

// Check team on initial load
validateTeamSlug()

// Watch changes in team
watch(() => team.slug, () => {
  validateTeamSlug()
})
</script>
